import { FC, useRef } from 'react';
import { motion, useInView } from 'framer-motion';

interface FadeTextProps {
  text: React.ReactNode;
  delay?: number;
  className?: string;
  progressive?: boolean;
  inViewTrigger?: boolean;
}

export const FadeText: FC<FadeTextProps> = ({
  text,
  delay = 0,
  className,
  progressive = false,
  inViewTrigger = false,
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });
  const shouldAnimate = inViewTrigger ? inView : true;

  if (!progressive) {
    return (
      <motion.span
        ref={inViewTrigger ? ref : undefined}
        className={className}
        initial={{ opacity: 0 }}
        animate={shouldAnimate ? { opacity: 1 } : {}}
        transition={{ duration: 1, delay }}
      >
        {text}
      </motion.span>
    );
  }

  const words = typeof text === 'string' ? text.split(' ') : [text];

  return (
    <div ref={inViewTrigger ? ref : undefined} className={className}>
      {words.map((word, index) => (
        <motion.span
          key={index}
          initial={{ opacity: 0, y: 10 }}
          animate={shouldAnimate ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: delay + index * 0.1 }}
          className="inline"
        >
          {word}
          {index < words.length - 1 ? ' ' : ''}
        </motion.span>
      ))}
    </div>
  );
};
